import * as React from 'react';
import ContentTile from './ContentTile';

export default () => (
  <ContentTile color="#0067F4">
    {/* The sidebar's Overview icon. */}
    <rect x="4.5" y="4.5" width="5" height="5" rx="1.5" />
    <rect x="14.5" y="4.5" width="5" height="5" rx="1.5" />
    <rect x="4.5" y="14.5" width="5" height="5" rx="1.5" />
    <rect x="14.5" y="14.5" width="5" height="5" rx="1.5" />
  </ContentTile>
);
